export enum MessageSender {
  USER = 'USER',
  AGENT = 'AGENT',
}

export enum MessageType {
  USER_MESSAGE = 'USER_MESSAGE',
  AGENT_RESPONSE = 'AGENT_RESPONSE',
  SYSTEM_MESSAGE = 'SYSTEM_MESSAGE',
  SESSION_START = 'SESSION_START',
  SESSION_END = 'SESSION_END',
  CHAT_FLAGGED = 'CHAT_FLAGGED',
}

export interface VisitorResponse {
  id: number;
  visitor_id: string;
  first_name: string | null;
  surname: string | null;
  email: string | null;
  member_number: string | null;
  created_at: string;
  updated_at: string;
  last_activity: string;
  has_unread_messages: boolean;
  is_flagged: boolean;
}

export interface MessageResponse {
  id: number;
  visitor_id: number;
  sender: MessageSender;
  content: string;
  message_type: MessageType;
  session_id: string;
  created_at: string;
  show_date_divider: boolean;
}

export interface ChatExportInfo {
  generated_at: string;
  window: {
    start: string;
    end: string;
  };
  session_count: number;
  message_count: number;
  file_size_bytes: number;
  download_filename: string;
}
